// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab_tab__3zNqX","active":"Tab_active__1QnzX","passive":"Tab_passive__2LUj2"};